import React, { FC, MouseEventHandler } from 'react';

import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { AppBar, Toolbar, Typography, IconButton, Hidden } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';

import { LanguageSwitcher } from '../languages';
import awsConfig from '../../aws-exports';
import { getHighlightsLabel } from '../../utils/highlightsLabel';

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		appBar: ({ sidebarWidth }: StyleProps) => ({
			[theme.breakpoints.up('lg')]: {
				width: `calc(100% - ${sidebarWidth}px)`,
				marginLeft: sidebarWidth
			}
		}),
		menuButton: {
			marginRight: theme.spacing(2),
			[theme.breakpoints.up('lg')]: {
				display: 'none'
			}
		},
		languageSwitcher: {
			marginLeft: theme.spacing(2)
		},
		grow: {
			flexGrow: 1
		}
	})
);

const Header: FC<HeaderProps> = ({ environment, sidebarWidth, onOpenMobileSidebar }) => {
	const classes = useStyles({ sidebarWidth });
	const highlightsLabel = getHighlightsLabel(awsConfig.accountName);
	const displayEnvironment = awsConfig.accountName.toLowerCase().includes('integration') ? 'integration' : environment;

	return (
		<AppBar position='fixed' className={classes.appBar}>
			<Toolbar>
				<IconButton
					data-testid='header-sidebar-button'
					color='inherit'
					aria-label='open drawer'
					edge='start'
					onClick={onOpenMobileSidebar}
					className={classes.menuButton}>
					<MenuIcon />
				</IconButton>
				<Hidden mdUp implementation='css'>
					<Typography variant='h6'>{highlightsLabel}</Typography>
				</Hidden>
				<Hidden smDown implementation='css'>
					<Typography variant='h6'>{highlightsLabel} Service</Typography>
				</Hidden>
				<div className={classes.grow} />
				<Typography variant='subtitle1' display='inline'>
					env: <strong>{displayEnvironment}</strong>
				</Typography>
				<div className={classes.languageSwitcher}>
					<LanguageSwitcher />
				</div>
			</Toolbar>
		</AppBar>
	);
};

export default Header;

type StyleProps = {
	sidebarWidth: number;
};

type HeaderProps = {
	environment: string;
	sidebarWidth: number;
	onOpenMobileSidebar: MouseEventHandler<HTMLButtonElement>;
};
